import React, { useEffect, useState } from 'react';
import styles from './NewsCard.module.scss';
import moment from 'moment';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import { useDeleteNews } from '../../../Hooks/News';
import NewsInfoModal from './NewsInfoModal';
import newsUpdated from '../../../assets/Imagess/news-updated.png';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import ActivityStatus from '../../Atoms/Inputs/ActivityStatus';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function NewsCard({ program, refetchNews }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const customizedToast = useToast();
  const {
    mutate: deleteNews,
    isLoading: isDeletingNews,
    isSuccess,
  } = useDeleteNews(program?.newsId);

  useEffect(() => {
    setIsActive(program?.isActive);
  }, [program]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-news/${program?.newsId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetchNews();
  }, [isDeletingNews]);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open('تم الحذف بنجاح');
    }
  }, [isSuccess]);

  const activateNews = useMutation({
    mutationFn: () => {
      return axios.post(
        API_URL + `/api/News/ActivateNews/${program?.newsId}/${!isActive}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: () => {
      setIsActive(!isActive);
      refetchNews();
      customizedToast.open('تم تحديث حالة الأخبار بنجاح');
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  return (
    <div className={styles['news-card']}>
      <img
        src={sanitizeAndValidateUrl(`${program?.url}${program?.image}`)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = noImageFound;
        }}
        className={styles['news-card-image']}
        onClick={() => setShowInfo(true)}
      />
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <p className={styles['name']}>{program?.category_AR}</p>
          <p className={styles['date']}>
            {moment(program?.newsDate).format('DD/MM/YYYY')}
          </p>
        </div>
        <div className={styles['row']}>
          <div className={styles['description']}>
            <p className={styles['title']}>{program?.title_AR}</p>
          </div>
          <div style={{ maxWidth: '200px' }}>
            <InfoButton
              icon={moreInfo}
              className={styles['more-info']}
              data={menuItems}
              left
            />
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title='الأخبار'
          handleDelete={() => {
            deleteNews();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingNews}
        />
      )}
      {showInfo && (
        <NewsInfoModal
          news={program}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
      <ActivityStatus isActive={isActive} activate={activateNews} />
    </div>
  );
}

export default NewsCard;
